import React from 'react';
import { MOCKUP_IMAGES } from '../data/content';
import { CTAButton } from './CTAButton';
export function About() {
  return <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-16" data-id="element-20" data-mp="2ps9vxdzgbqho">
      <div className="mx-auto max-w-3xl" data-id="element-21" data-mp="2tsk9bbpkpj6k">
        <p className="text-center text-[12px] font-extrabold uppercase tracking-[0.18em] text-brand" data-id="element-22" data-mp="2trr106ayulmb">
          🏥 Sobre la autora
        </p>
        <h2 className="mt-3 text-center font-serif text-[28px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-23" data-mp="33rhv46vm6ylv">
          Dra. Karito
        </h2>

        <div className="mt-8 grid gap-6 sm:grid-cols-5 sm:items-start" data-id="element-24" data-mp="38orsc8p8wek9">
          <div className="sm:col-span-2" data-id="element-25" data-mp="3di461nsdz0y8">
            <img src={MOCKUP_IMAGES.doctora} alt="Retrato de la Dra. Karito, autora de Ruta Clínica GLP-1" className="mx-auto w-full max-w-[260px] rounded-2xl object-cover shadow-lift" loading="lazy" data-id="element-26" data-mp="3dj5sspirlbvs" />
          </div>
          <div className="sm:col-span-3" data-id="element-27" data-mp="3rh3w8zvjrnwi">
            <p className="text-[14.5px] leading-relaxed text-navy-900/85" data-id="element-28" data-mp="2lqz60fpwv2sa">
              La Dra. Karito creó Ruta Clínica GLP-1™ con un objetivo muy claro:
              convertir uno de los tratamientos que más dudas genera actualmente
              en una secuencia de decisiones clínicas simples, ordenadas y
              respaldadas por evidencia.
            </p>
            <p className="mt-4 text-[14.5px] leading-relaxed text-navy-900/85" data-id="element-29" data-mp="27tiyf0vvp2yy">
              Después de revisar las principales guías internacionales y
              condensar miles de páginas de información, desarrolló una
              metodología práctica para que cualquier médico pueda recorrer el
              mismo camino que seguiría un especialista, desde la selección del
              paciente hasta el seguimiento a largo plazo.
            </p>
            <p className="mt-4 rounded-xl bg-navy-50 p-4 text-[14px] font-semibold leading-snug text-navy-900" data-id="element-30" data-mp="3o6r6nc48zf17">
              El resultado es una Ruta Clínica diseñada para ahorrar tiempo,
              reducir la incertidumbre y aumentar la seguridad al prescribir
              GLP-1.
            </p>
          </div>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-31" data-mp="b45d98o75j6l">
          <CTAButton label="Quiero seguir su Ruta Clínica" note="Método basado en guías ADA, AACE y EASD" data-id="element-32" data-mp="3tjfs1jvga69l" />
        </div>
      </div>
    </section>;
}